import { JSONEditor as BaseEditor } from '@json-editor/json-editor'
import _ from 'lodash'

// include custom configuration and feature set
import { options } from './defaults'
import resolvers from './resolvers'
import editors from './editors'
import themes from './themes'
import iconlibs from './iconlibs'
import { en } from './languages'

class JSONEditor extends BaseEditor {
  // add shorthand for single event listener
  once (event, func) {
    this.on(event, (...args) => {
      this.off(event)
      func(...args)
    })
  }
}

// add customizations
Object.assign(JSONEditor.defaults.options, options)
Object.assign(JSONEditor.defaults.editors, editors)
Object.assign(JSONEditor.defaults.themes, themes)
Object.assign(JSONEditor.defaults.iconlibs, iconlibs)
Object.assign(JSONEditor.defaults.languages.en, en)

// add resolvers
JSONEditor.defaults.resolvers = resolvers.concat(JSONEditor.defaults.resolvers)

export default JSONEditor
